<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>상품 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="cancelUpdate">상품 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">상품 ID</td>
            <!-- TODO <td><input type="input" v-model="product.productAlias" tabindex="1"/></td> -->
            <td>-자동생성-</td>
          </tr>
          <tr>
            <td class="header">상품 영문 이름</td>
            <td><input type="input" v-model="product.productEngName" tabindex="1"/></td>
          </tr>
          <tr>
            <td class="header">공급 가격</td>
            <td><input type="input" v-model="product.supplyPrice" tabindex="5"/></td>
          </tr>
          <tr>
            <td class="header">유통 시간(시)</td>
            <td><input type="input" v-model="product.expirePeriod" tabindex="7"/></td>
          </tr>
          <tr>
            <td class="header">소유 회사</td>
            <td>
              <select v-model="product.companyID" @change="selectCompany(product.companyID)" tabindex="8">
                <option v-for="item in companyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">바코드</td>
            <td><input type="input" v-model="product.barcode" tabindex="1"/></td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">상품 이름</td>
            <td><input type="input" v-model="product.productName" tabindex="2"/></td>
          </tr>
          <tr>
            <td class="header">상품 종류</td>
            <td><input type="input" v-model="product.productType" tabindex="3"/></td>
          </tr>
          <tr>
            <td class="header">판매 가격</td>
            <td><input type="input" v-model="product.salePrice" tabindex="6"/></td>
          </tr>
          <tr>
            <td class="header">무게(g)</td>
            <td><input type="input" v-model="product.weight" tabindex="4"/></td>
          </tr>
          <tr>
            <td class="header">소유 부서</td>
            <td>
              <select v-model="product.divisionID" tabindex="9">
                <option v-for="item in divisionList" :key="item.divisionID" :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
          </tr>
        </table>
      </div>
      <div class="table-content">
        <table>
          <tr>
            <td class="header">상품 사진</td>
            <td>
              <div>
                <ProductThumbnail editable @edited:thumbnail="editThumbnail"></ProductThumbnail>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line"
          @click="excuteUpdate"
        >
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ProductThumbnail from '@/components/product/ProductThumbnail';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  components: {
    ProductThumbnail,
    ButtonLoading,
  },
  props: [
    'company',
  ],
  data: () => ({
    companyList: [],
    divisionList: [],
    product: {
      productName: null,
      productEngName: null,
      productType: null,
      supplyPrice: null,
      salePrice: null,
      weight: null,
      expirePeriod: null,
      barcode: null,
      companyID: null,
      divisionID: null,
    },
    thumbnail: null,
    processing: false,
  }),
  created() {
    this.fetchCompanyList();

    if (this.company.companyID) {
      this.product.companyID = this.company.companyID;
      this.selectCompany(this.company.companyID);
    }
  },
  methods: {
    async fetchCompanyList() {
      try {
        const listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          throw new Error(`Response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${list.data.resultCode}"`);
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];
          if (p.scope === 3) {
            companyList.push(p);
          }
        }
        this.companyList = companyList;
      } catch (e) {
        console.error(e);
      }
    },
    async selectCompany(companyID) {
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${companyID}?withDivisions=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        this.divisionList = result.data.company.divisions;
      } catch (e) {
        console.error(e);
      }
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        this.product.supplyPrice = parseInt(this.product.supplyPrice, 10);
        this.product.salePrice = parseInt(this.product.salePrice, 10);
        this.product.weight = parseFloat(this.product.weight);
        this.product.expirePeriod = parseInt(this.product.expirePeriod, 10);

        const createUrl = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product`;

        const createResult = await this.$http.post(createUrl,
          this.product,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        if (this.thumbnail !== null) {
          const uploadUrl = `${Configuration.value('CSTORAGE_ADDRESS',
          )}/api/v1/cstorage/${createResult.data.trID}/thumbnail`;

          const formData = new FormData();
          formData.append('thumbnail', this.thumbnail);

          this.$http.post(uploadUrl,
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                'Content-Type': 'multipart/form-data',
              },
            },
          );
        }

        if (this.company.companyID) {
          const company = {
            id: this.company.companyID,
            name: this.company.companyName,
            alias: this.company.companyAlias,
          };
          this.processing = false;
          this.$emit('refreshList', company, 'company', 1);
        } else {
          this.processing = false;
          this.$emit('refreshList', null, 'all', 1);
        }
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      if (this.company.companyID) {
        const company = {
          id: this.company.companyID,
          name: this.company.companyName,
          alias: this.company.companyAlias,
        };
        this.$emit('refreshList', company, 'company');
      } else {
        this.$emit('refreshList', null, 'all');
      }
    },
    editThumbnail(thumbnail) {
      this.thumbnail = thumbnail;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/ProductCreate.vue